import { Box, Typography } from '@mui/material';
import logoPol from '../assets/logoPol.png';
import { Link, useNavigate } from 'react-router-dom';

const TransitionTypography = ({ children, ...rest }) => {
  return (
    <Typography
      fontSize={15}
      color="#5e636e"
      sx={{
        cursor: 'pointer',
        transition: 'color 0.3s ease',
        '&:hover': { color: 'link.main' },
      }}
      {...rest}
    >
      {children}
    </Typography>
  );
};

const Footer = () => {
  const navigate = useNavigate();

  const thesmikoPlaisio = () => {
    navigate('/thesmiko-plaisio');
  };

  /*  const downloadManual = async () => {
    try {
      await downloadStaticFile('map_manual.pdf');
    } catch (err) {}
  }; */

  const redirectToManual = () => {
    navigate('/manual');
  };

  return (
    <>
      <Box
        sx={{
          py: '1rem',
          borderTop: '4px solid',
          borderColor: 'link.secondary',
          backgroundColor: 'gray.footer',
          width: '100%',
        }}
      >
        <Box
          sx={{
            px: '15px',
            display: { xs: 'block', md: 'flex' },
            height: { xs: 'auto', md: '72px' },
            py: '14px',
            alignItems: 'center',
            justifyContent: 'space-around',
          }}
        >
          <Box style={{ fontSize: '14px', color: '#5e636e' }}>
            © Powered by Knowledge A.E - 01 SOLUTIONS HELLAS A.E 2024 για το
            <Typography
              component={Link}
              sx={{ fontSize: '14px', color: 'link.main', px: 0.5 }}
              to="https://www.culture.gov.gr/"
              target="_blank"
            >
              Υπουργείο Πολιτισμού
            </Typography>
          </Box>

          <Box>
            <Box mb={1} display={'inline-flex'} gap={2}>
              <TransitionTypography onClick={redirectToManual}>
                Εγχειρίδιο Χρήστη
              </TransitionTypography>
              <Typography color={'#5e636e'}>|</Typography>
              <TransitionTypography onClick={thesmikoPlaisio}>
                Θεσμικό Πλαίσιο
              </TransitionTypography>
            </Box>
          </Box>

          <Box sx={{ display: 'flex', gap: 2 }}>
            <img height="50px" src={logoPol} alt="" />
          </Box>
        </Box>
      </Box>
    </>
  );
};
export default Footer;
